import {
  MerchantGetInvoiceResponse,
  MerchantInvoice,
  EditInvoicePayload,
  Invoice,
  PaymentLinkInvoice,
  InvoiceDetails,
  MerchantInvoiceToken,
} from '@types'
import { Service } from '@tino-frontend/adapters'
import { managerGetMerchantInvoiceTransform } from 'services/transformers'

export class InvoicesService {
  constructor(
    private readonly merchantBff: Service,
    private readonly supplierBff: Service
  ) {
    this.merchantBff = merchantBff
    this.supplierBff = supplierBff
  }

  async buyerInvoiceById(
    companyId: string,
    invoiceId: string
  ): Promise<MerchantInvoice> {
    return this.merchantBff
      .get<
        unknown,
        MerchantGetInvoiceResponse
      >(`/v1/company/${companyId}/invoice/${invoiceId}`)
      .then(managerGetMerchantInvoiceTransform)
  }

  async buyerInvoiceByInstallmentId(
    companyId: string,
    installmentId: string
  ): Promise<MerchantInvoiceToken> {
    return this.merchantBff.get<unknown, MerchantInvoiceToken>(
      `/v1/company/${companyId}/installment/${installmentId}/nfe`
    )
  }

  showInvoice(
    invoiceId: string,
    limit_reservation_id: string
  ): Promise<Invoice> {
    return this.supplierBff.get(`/v1/invoices/${invoiceId}`, {
      params: {
        limit_reservation_id,
      },
    })
  }

  cancelInvoice(supplierId: string, invoiceId: string) {
    return this.supplierBff.delete(`/v1/invoices/${invoiceId}`, {
      params: {
        supplier_id: supplierId,
      },
    })
  }

  editInvoice({
    invoice_id,
    ...payload
  }: EditInvoicePayload): Promise<unknown> {
    return this.supplierBff.patch(`/v1/invoices/${invoice_id}`, payload)
  }

  limitReservationInvoicesById(
    limitReservationId: string
  ): Promise<PaymentLinkInvoice[]> {
    return this.supplierBff.get(
      `/v1/limit-reservations/${limitReservationId}/invoices`
    )
  }

  getInvoiceDetails(invoiceId: string): Promise<InvoiceDetails> {
    return this.supplierBff.get(`/v1/invoices/${invoiceId}/nfe`)
  }

  downloadNfeXml(token: string): Promise<Blob> {
    return this.merchantBff.get(`/v1/nfe/${token}`, {
      responseType: 'blob',
    })
  }

  downloadNfePdf(token: string): Promise<Blob> {
    return this.merchantBff.get(`/v1/nfe/pdf/${token}`, {
      responseType: 'blob',
    })
  }
}
